require('bootstrap-select/dist/js/bootstrap-select');

const langMap = {
    en: "en_US",
    bg: "bg_BG",
    de: "de_DE",
    fr: "fr_FR",
    es: "es_ES",
    pl: "pl_PL",
    pt: "pt_PT",
};

if (document.documentElement.lang in langMap) {
    require("bootstrap-select/js/i18n/defaults-" + langMap[document.documentElement.lang]);
} else {
    require("bootstrap-select/js/i18n/defaults-en_US");
}
